import {useEffect, useRef} from 'react'

// We need an internal lock counter. The global scroll lock is only released when the counter reaches zero.
// There can be multiple modals open at the same time due to transitions.
let lockCounter = 0

const updateScrolling = (lock: boolean) => {
  lockCounter += lock ? 1 : -1

  if (lockCounter === 0) {
    window.document.body.style.overflow = ''
  } else {
    window.document.body.style.overflow = 'hidden'
  }
}

export default (lock: boolean) => {
  const lockRef = useRef(false)

  useEffect(() => {
    if (lock && !lockRef.current) {
      updateScrolling(true)
      lockRef.current = true
    }

    return () => {
      if (lockRef.current) {
        updateScrolling(false)
        lockRef.current = false
      }
    }
  }, [lock])
}
